import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit {
  hasError = false;
  errorCode = '';
  errorMessage = '';
  showDetails = false;

  constructor(
    private auth: AuthService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    // 1. Écouter les erreurs émises par le SDK Auth0
    this.auth.error$.subscribe((error) => {
      if (error) {
        const err = error as Error & { error?: string; error_description?: string };
        this.setError(
          err.error || err.name || 'access_denied',
          err.error_description || err.message || 'Accès non autorisé'
        );
      }
    });

    // 2. Écouter les paramètres éventuels passés dans l'URL (?error=...&error_description=...)
    this.route.queryParams.subscribe((params) => {
      if (params['error'] || params['error_description']) {
        this.setError(
          params['error'] || 'access_denied',
          params['error_description'] || 'Accès non autorisé'
        );
      }
    });
  }

  private setError(code: string, message: string) {
    this.hasError = true;
    this.errorCode = code;
    this.errorMessage = message;
  }

  get isAccessDenied(): boolean {
    const code = (this.errorCode || '').toLowerCase();
    const msg = (this.errorMessage || '').toLowerCase();
    return code === 'access_denied' || msg.includes('profil') || msg.includes('not found') || msg.includes('droits');
  }

  login() {
    this.hasError = false;
    this.auth.loginWithRedirect();
  }

  retryLogin() {
    // Force la réouverture de la sélection de compte pour permettre de changer d'utilisateur
    this.auth.loginWithRedirect({
      authorizationParams: {
        prompt: 'login'
      }
    });
  }

  toggleDetails() {
    this.showDetails = !this.showDetails;
  }

  dismissError() {
    this.hasError = false;
  }
}
